export enum ModalState {
    OPENED,
    CLOSED
};


// WEBPACK FOOTER //
// ./app/classes/modal.ts